export enum Events {
  None,
  JobPostedEvent, //a new job is posted or drafted
  /* job related but non job events*/
  QuoteChangedEvent, //refresh
  VariationCancelledEvent, //refresh
  /* job related but non job events*/

  /**job events/ */
  //  SwitchJobEvent, //refresh (implemented with add variation event)
  ReAwardJobEvent, //refresh
  JobApprovedEvent, //refresh (tenant posted job approval)
  OwnerApprovalChangedEvent, //refresh
  JobPayerChangedEvent, //refresh
  JobCompletedEvent, //refresh (ApproveInvoice)
  ApprovalDraftedEvent, //refresh
  VariationChangedEvent, //refresh
  VariationApprovalOverridedEvent, //refresh
  VariationAddedEvent, //refresh (AddJobVariation)
  JobEditedEvent, //refresh (no state change but refresh job)
  DraftedJobUpdateEvent, // refresh(Update drafted job warrenty and tradee)
  JobRejectedEvent, //refresh (tenant posted job reject)
  JobOwnerOverridedEvent, //refresh from award hence no need to refresh due to this (OwnerOverride)
  JobDeactivateEvent, //refresh (Deactivte)
  InvoiceCancelEvent,
  UpdateRecurringJobEvent, // refresh(Update recurrence of the job)
  JobMovedToPendingInvoice,
  InviteTradesToJob,
  RemindTredeToCompleteEvent,
  RemindTredeToQuoteEvent,
  JobConvertEvent,
  RemindOwnerEvent,
  /**job events/ */

  /*custom events*/
  TeamSelectionChangedEvent,
  JobNoteAddedEvent,
  JobStatusChangedEvent,
  JobEmailSentEvent,
  RequestRevisionEvent,
  JobAttachmentEditEvent,
  JobEmailTemplateEvent,
  TenancyInvoicesSaveEvent,

  DashboardReloaded,
  OrganizationSettingsChangedEvent,
  // OrganisationSettings,

  PaymentDetailChangedEvent,
  QuoteCancelEvent,
  ServiceTypeChangeEvent,
  PropertyUpdatedEvent,

  //Wizard event
  RelatedJobStatusChangedEvent, //refresh wizard

   /**asset events/ */
  ApproveAssetEvent,
  DeleteAssetEvent,
  SentToTenantAssetEvent,
  RefreshAssetCountEvent,
  EditAssetEvent

}
